import { TabItem } from '@components/Tabs/Tabs.types';

import { TabType } from '@features/api/response/tabContent/TabType';
import Portfolio from '@pages/Portfolio/Portfolio';
import InvestmentStructure from '@pages/InvestmentStructure/InvestmentStructure';
import ProductOverView from '@pages/ProductOverView/ProductOverView';
import ProductCalculator from '@pages/ProductCalculator/ProductCalculator';
import { IntlShape } from 'react-intl';
import EDocument from '@pages/EDocument/EDocument';
import KeyTerms from '@pages/KeyTerms/KeyTerms';
import Highlights from '@pages/Highlights/Highlights';
import { Tab } from '@features/api/response/ProductDetails';
import { NavigateFunction } from 'react-router-dom';

import PortfolioRestrictedBackground from '@assets/backgrounds/products/desktop/restricted-product-portfolio-tab.png';
import HighlightsRestrictedBackground from '@assets/backgrounds/products/desktop/restricted-product-highlights-tab.png';
import CalculatorRestrictedBackground from '@assets/backgrounds/products/desktop/restricted-product-calculator-tab.png';
import InvestmentStructureRestrictedBackground from '@assets/backgrounds/products/desktop/restricted-product-investment-struct-tab.png';
import KeyTermsRestrictedBackground from '@assets/backgrounds/products/desktop/restricted-product-key-terms-tab.png';
import EDocumentsRestrictedBackground from '@assets/backgrounds/products/desktop/restricted-product-edocuments-tab.png';

import PortfolioRestrictedBackgroundMobile from '@assets/backgrounds/products/mobile/restricted-product-portfolio-tab.png';
import HighlightsRestrictedBackgroundMobile from '@assets/backgrounds/products/mobile/restricted-product-highlights-tab.png';
import CalculatorRestrictedBackgroundMobile from '@assets/backgrounds/products/mobile/restricted-product-calculator-tab.png';
import InvestmentStructureRestrictedBackgroundMobile from '@assets/backgrounds/products/mobile/restricted-product-investment-struct-tab.png';
import KeyTermsRestrictedBackgroundMobile from '@assets/backgrounds/products/mobile/restricted-product-key-terms-tab.png';
import EDocumentsRestrictedBackgroundMobile from '@assets/backgrounds/products/mobile/restricted-product-edocuments-tab.png';

export const getTabData = (
  tab: Tab,
  intl: IntlShape,
  navigate: NavigateFunction,
  productId?: string
): TabItem & {
  restrictedTabBackground?: string;
  restrictedTabBackgroundMobile?: string;
} => {
  const getBaseData = (tabType: TabType) => {
    switch (tabType) {
      case TabType.CALCULATOR: {
        return {
          label: intl.formatMessage({ id: 'product.tabs.calculator' }),
          component: <ProductCalculator />,
          restrictedTabBackground: CalculatorRestrictedBackground,
          restrictedTabBackgroundMobile: CalculatorRestrictedBackgroundMobile,
        };
      }
      case TabType.EDOCUMENTS: {
        return {
          label: intl.formatMessage({ id: 'product.tabs.eDocuments' }),
          component: <EDocument type={TabType.EDOCUMENTS} />,
          restrictedTabBackground: EDocumentsRestrictedBackground,
          restrictedTabBackgroundMobile: EDocumentsRestrictedBackgroundMobile,
        };
      }
      case TabType.LEGALS: {
        return {
          label: intl.formatMessage({ id: 'product.tabs.legals' }),
          component: <EDocument type={TabType.LEGALS} />,
          restrictedTabBackground: EDocumentsRestrictedBackground,
          restrictedTabBackgroundMobile: EDocumentsRestrictedBackgroundMobile,
        };
      }
      case TabType.WHY_SFPE: {
        return {
          label: intl.formatMessage({ id: 'product.tabs.sfpe' }),
          component: <Highlights />,
          restrictedTabBackground: HighlightsRestrictedBackground,
          restrictedTabBackgroundMobile: HighlightsRestrictedBackgroundMobile,
        };
      }
      case TabType.INVESTMENTSTRUCTURE: {
        return {
          label: intl.formatMessage({ id: 'product.tabs.investmentStructure' }),
          component: <InvestmentStructure />,
          restrictedTabBackground: InvestmentStructureRestrictedBackground,
          restrictedTabBackgroundMobile:
            InvestmentStructureRestrictedBackgroundMobile,
        };
      }
      case TabType.KEYTERMS: {
        return {
          label: intl.formatMessage({ id: 'product.tabs.keyTerms' }),
          component: <KeyTerms />,
          restrictedTabBackground: KeyTermsRestrictedBackground,
          restrictedTabBackgroundMobile: KeyTermsRestrictedBackgroundMobile,
        };
      }
      case TabType.OVERVIEW: {
        return {
          label: intl.formatMessage({ id: 'product.tabs.overview' }),
          component: <ProductOverView />,
        };
      }
      case TabType.SEED_PORTFOLIO: {
        return {
          label: intl.formatMessage({ id: 'product.tabs.portfolio' }),
          component: <Portfolio />,
          restrictedTabBackground: PortfolioRestrictedBackground,
          restrictedTabBackgroundMobile: PortfolioRestrictedBackgroundMobile,
        };
      }
    }
  };

  return {
    ...getBaseData(tab.type),
    id: `${tab.id}`,
    tabProps: {
      onClick: () => {
        navigate(getTabPath(productId ?? '', tab.id));
      },
      value: `${tab.id}`,
    },
  };
};

export const getTabPath = (productId: string, tabId: string) =>
  `/product/${productId}/${tabId}`;
